import { string, object } from "yup";

export const createLoginSchema = (t) => object().shape({
  username: string().required(t('validation.username_required')),
  password: string().required(t('validation.password_required'))
});

// Keep default export for backwards compatibility
const loginSchema = object().shape({
  username: string().required("Le nom d'utilisateur est obligatoire"),
  password: string().required("Le mot de passe est obligatoire")
});

export default loginSchema;
